document.querySelectorAll(".accordion-titleone").forEach((title) => {
  title.addEventListener("click", () => {
    const item = title.parentElement;
    const content = item.querySelector(".accordion-contentone");

    const isOpen = item.classList.contains("active");

    // Close all
    document.querySelectorAll(".accordion-itemone").forEach((el) => {
      const c = el.querySelector(".accordion-contentone");
      el.classList.remove("active");
      c.style.height = "0px";
      el.querySelector(".icon").textContent = "+";
    });

    // Open current
    if (!isOpen) {
      item.classList.add("active");

      // Set height dynamically
      content.style.height = content.scrollHeight + "px";

      title.querySelector(".icon").textContent = "−";

      // Optional: reset to auto after animation (for responsive content)
      content.addEventListener(
        "transitionend",
        function () {
          if (item.classList.contains("active")) {
            content.style.height = "auto";
          }
        },
        { once: true }
      );
    }
  });
});